import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {signIn} from '../../../../redux/authentication/actionCreator'
import Alert from '../../../../components/alerts/alerts';

const ToastError = () => {
    const dispatch = useDispatch()
    const dialog = useSelector(state => state.auth.dialog)
    useEffect(() => {
        if (dialog) {
            window.scrollTo(0,document.body.scrollHeight);
            setTimeout(() => {
                dispatch({type:'RESET_DIALOG'})
            }, 5000);
        }
    }, [dialog])
    return(
        <Alert
            message=""
            description={dialog.message}
            type="error"
        />
    )
};


export default ToastError;
